import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/yoga/pose1.jpg";
import { API_BASE_URL } from "../../Config";
import { useSlugMenu } from "../../hooks/useSlugMenu";
import axios from "axios";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

const Mudra = () => {  const [allYogaPages, setAllYogaPages] = useState([]);
  const { selectedKey, handleMenuClick } = useSlugMenu(allYogaPages, "/mudra");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=mudra`);
        const json = await res.data;
        setAllYogaPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");

      if (home) return home.content;

      return `
 <h2 style="text-align:center; margin-bottom:30px;">Types of Yoga Mudras</h2>

<h3>1. Hasta Mudra - Hand gesture mudras</h3>
<p><strong>English meaning:</strong> Mudras made using the hands and fingers.</p>
<p>
  <strong>Explanation:</strong> These are the mudras that everyone knows and uses easily.
  For example, Jnana Mudra, Prana Mudra, Anjali Mudra etc.
</p>

<h3>2. Kaya Mudra - Body position mudras</h3>
<p><strong>English meaning:</strong> Mudras that involve the whole body, such as asanas.</p>
<p>
  <strong>Explanation:</strong> Although they look like asanas, their main purpose is to guide
  the energy flow of the body. Example: Yoga Mudrasana.
</p>

<h3>3. Mana Mudra - Head mudras</h3>
<p><strong>English meaning:</strong> Mudras that involve the sense organs such as eyes, nose, tongue, lips, ears.</p>
<p>
  <strong>Explanation:</strong> These are very powerful during meditation.
  Example: Shambhavi Mudra – Looking between the eyebrows.
</p>

<h3>4. Bandha Mudra - Bandha (lock) based mudras</h3>
<p><strong>English meaning:</strong> Mudras that use all three Bandhas (locks).
The vocal, respiratory and pelvic muscles are involved.</p>
<p>
  <strong>Explanation:</strong> These are done by combining the important energy locks (Bandhas).
</p>

<h3>5. Adhara Mudra - Pelvic area mudras</h3>
<p><strong>English meaning:</strong> Mudras that engage the pelvic muscles.</p>
<p>
  <strong>Explanation:</strong> These are used for concentrating energy in the lower part of the body.</p>
<p>
  <strong>Key point:</strong> All these five types, except Hasta Mudras, are very advanced yoga exercises.
  They should be learned and practiced only under the supervision of an experienced yoga guru.
</p>

<hr style="margin:40px 0;" />

<h2 style="text-align:center; margin-bottom:20px;">Benefits of Mudras</h2>
<p>Mudras benefit physical and mental health in many ways. Its main benefits are as follows:</p>

<h3>1. For Physical Health:</h3>
<ul>
  <li>Controlling the body elements: The fingers are connected to different parts and elements of the body.</li>
  <li>Reducing physical diseases: Helps reduce respiratory disorders, digestive problems, rheumatic diseases, colds, etc.</li>
  <li>Strengthening the nervous system: Improves the connection between the nerves and the brain.</li>
</ul>

<h3>2. For Mental Health:</h3>
<ul>
  <li>Reducing stress and anxiety: Helps calm the mind and control anxious thoughts.</li>
  <li>Increasing mental concentration: Helps improve focus and is useful for meditation.</li>
  <li>Emotional balance: Helps relieve negative emotions such as anger and fear.</li>
</ul>

<h3>3. Spiritual Growth:</h3>
<ul>
  <li>
    Activation of energy centers (chakras): Helps awaken kundalini energy and stimulate the chakras.
  </li>
  <li>
    Manifestation of inner energy: Leads to spiritual enlightenment and inner peace.
  </li>
</ul>
`;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  const menuItems = [
    ...allYogaPages.map((p) => ({
      key: p._id,
      label: p.yogaType,
    })),
    { key: "home", label: "Back to Main Page" },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px", // 👈 decrease height here
            backgroundImage: `url(${pose1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Explore Mudras
          </div>

          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              color: "#ffffffA2",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 500,
              textAlign: "center",
            }}
            itemStyle={{ color: "#fff" }}
            onClick={handleMenuClick}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card
                  className="inner_card"
                  style={{ borderRadius: "12px", padding: "24px" }}
                >
                  {selectedContent}
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default Mudra;
